import { createGraphqlFetcher } from '@apis/createFetcher';

const EngageV4UserGroup = `{
    type
    value
}`;

const Goal = `{
    id
    sid
    name
    content
    description
    createTime
    updateTime
    createBy
    updateBy
    status
    count
}`;

const EngageV4CreativeTerminal = `{
    id
    type
    status
    popup
    stickybar
    inline
    code
    engageVersionID
    redirect
}`;

const EngageV4Version = `{
    id
    name
    rate
    controlGroup
    screenshot
    engageID
    terminals ${EngageV4CreativeTerminal}
}`;

const engageConfig = `{
    antiFlicker
    id
    sid
    name
    status
    createTime
    updateTime
    lastPauseTime
    firstRunTime
    hasForm
    hasSync
    isVersionEvent
    createBy
    modifierBy
    hasVariant
    engageVersion
    engageType
    baseURL
    screenshot
    schedule
    conditions
    usergroups ${EngageV4UserGroup}
    versions ${EngageV4Version}
    firstRunABTestTime
    enableABTest
}`;

const engageData = `{
    engageViewCount
    engageView
    engageClick
    engageClickRate
    engageClose
    engageCloseRate
    engageSubmit
    engageSubmitRate
    goal {
        goalId
        rate
        name
        number
    }
    avgSessionDuration
    bounceRate
    sessionViewDepth
}`;

const templateSchema = `{
    id
    name
    description
    pcThumbnail
    pcWidgets
    pcWidgetLayout
    mobileThumbnail
    mobileWidgets
    mobileWidgetLayout
    deviceType
    type
    tag
    area
    sort
    recommendationLocation
}`;

const GoalMember = `{
  goalId
  rate
  number
  name
  uplift
  isBest
  bestProbability
}`;

const EngageV4ListData = `{
    engageView
    engageViewCount
    engageClick
    engageClose
    engageSubmit
    engageClickRate
    engageCloseRate
    engageSubmitRate
    goal ${GoalMember}
    avgSessionDuration
    bounceRate
    sessionViewDepth
}`;

const EngageV4ListVersion = `{
  id
  name
  rate
  controlGroup
  screenshot
  data ${EngageV4ListData}
  terminals ${EngageV4CreativeTerminal}
}`;

const engageV4VersionListMember = `{
    id
    versions ${EngageV4ListVersion}
    engageData ${EngageV4ListData}
}`;

const apis = {
    queryEngageV4ConfigList: {
        name: 'queryEngageV4ConfigList',
        query: `query queryEngageV4ConfigList($profileId:String!){
                    queryEngageV4ConfigList(profileId:$profileId)${engageConfig}
                }`
    },
    queryEngageV4List: {
        name: 'queryEngageV4List',
        query: `query queryEngageV4List {
                    queryEngageV4List{
                        engageConfig {
                            id
                        },
                        engageData ${engageData}
                    }
                }`
    },
    queryEngageV4VersionList: {
        name: 'queryEngageV4VersionList',
        query: `query queryEngageV4VersionList {
            queryEngageV4VersionList ${engageV4VersionListMember}
        }`
    },
    getPreviewKey: {
        name: 'previewKey',
        query: `mutation previewKey($data: PreviewEngagement!){
            previewKey(data: $data)
        }`
    },
    getListColumns: {
        name: 'accountProfile',
        query: `query accountProfile($where: AccountProfileUniqueInput!){
            accountProfile(where:$where) {
                campaignReportColumns
            }
        }`
    },
    updateAccountProfile: {
        name: 'updateAccountProfile',
        query: `mutation updateAccountProfile($data: AccountProfileInput!, $where: AccountProfileUniqueInput!){
            updateAccountProfile(data:$data, where:$where) {
                campaignReportColumns
            }
        }`
    },
    getAllGoalList: {
        name: 'getGoals',
        query: `query getGoals($where: GoalListWhereUniqueInput!){
            goals(where:$where) {
                id
                name
                content
                description
                engagements
                currentResult
                lastResult
            }
        }`
    },
    getTemplateInfoByID: {
        name: 'getEngageV4TemplateById',
        query: `
            query getEngageV4TemplateById($id: ID!){
                getEngageV4TemplateById(id: $id) ${templateSchema}
            }
        `
    },
    judgmentUrlCondition: {
        name: 'judgmentUrlCondition',
        query: `
            query judgmentUrlCondition($input: JudgmentUrlInput!){
                judgmentUrlCondition(input: $input){
                    url
                    status
                }
            }
        `
    }
};

export default createGraphqlFetcher(apis);
